import { provideStoreDevtools } from '@ngrx/store-devtools'

import { environment } from '@env'

// Runtime environment check (not just the build-time fileReplacements swap):
// devtools are only provided when the running environment is explicitly
// non-production, so any undetermined value keeps them disabled (fail-closed).
export const extProviders =
  environment.production === false
    ? [
        provideStoreDevtools({
          maxAge: 25,
          name: 'Performance BackOffice',
        }),
      ]
    : []
